import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const VIASICFETRANSPORT_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ViaSICFETransport.Name')
    .required()
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('value', 'Entity.ViaSICFETransport.Value')
    .required()
    .maxLength(50)
    .build(),
];

export const VIASICFETRANSPORT_CONFIG = {
  entityName: 'ViaSicfeTransport',
  localizationKey: 'Controlling::Entity.ViaSICFETransport',
  fields: VIASICFETRANSPORT_FIELDS,
  permission: 'ControllingLiquidations.ViaSicfeTransports',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
